import React from "react";
import styles from "./Button.module.scss";

export const Button = ({ title, icon, onClick, buttonStyle, titleStyle }) => {
  return (
    <div className={`${styles.button} ${buttonStyle}`} onClick={onClick}>
      {icon}
      <p className={`${styles.title} ${titleStyle}`}>{title}</p>
    </div>
  );
};
